module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Rotacja slajdów",
      "error": _vm.errors.autorotate
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.autorotate),
      callback: function($$v) {
        _vm.$set(_vm.form, "autorotate", $$v)
      },
      expression: "form.autorotate"
    }
  })], 1), _vm._v(" "), (_vm.form.autorotate) ? _c('el-form-item', {
    attrs: {
      "label": "Czas pomiędzy automatyczną zmianą slajdu",
      "error": _vm.errors.autorotate_interval
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.autorotate_interval),
      callback: function($$v) {
        _vm.$set(_vm.form, "autorotate_interval", $$v)
      },
      expression: "form.autorotate_interval"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Nowy slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "slide[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Podtytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['subtitle']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('subtitle')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('subtitle'), $$v)
        },
        expression: "slide[addLanguageSuffix('subtitle')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Video",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['video']
      }
    }, [_c('el-input', {
      model: {
        value: (slide.video),
        callback: function($$v) {
          _vm.$set(slide, "video", $$v)
        },
        expression: "slide.video"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Iframe",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['iframe']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (slide.iframe),
        callback: function($$v) {
          _vm.$set(slide, "iframe", $$v)
        },
        expression: "slide.iframe"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Grafika",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.image),
        callback: function($$v) {
          _vm.$set(slide, "image", $$v)
        },
        expression: "slide.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1), _vm._v(" "), _c('el-collapse', {
      staticClass: "collapse"
    }, [_c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "title": "szczegóły lewego przycisku"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa lewego przycisku",
        "error": _vm.errors.slides && _vm.errors.slides[i]['left_button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('left_button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('left_button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('left_button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: slide.left_button_link_key || slide.id + 'left',
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i]['left_button_link']
      },
      model: {
        value: (slide.left_button_link),
        callback: function($$v) {
          _vm.$set(slide, "left_button_link", $$v)
        },
        expression: "slide.left_button_link"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "title": "szczegóły prawego przycisku"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa prawego przycisku",
        "error": _vm.errors.slides && _vm.errors.slides[i]['right_button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (slide[_vm.addLanguageSuffix('right_button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('right_button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('right_button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: slide.right_button_link_key || slide.id + 'right',
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i]['right_button_link']
      },
      model: {
        value: (slide.right_button_link),
        callback: function($$v) {
          _vm.$set(slide, "right_button_link", $$v)
        },
        expression: "slide.right_button_link"
      }
    })], 1)], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj slajd")]), _vm._v(" "), (typeof _vm.errors.slides === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.slides) + "\n            ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac5f780"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/SlidesWidget.vue
// module id = 773
// module chunks = 0